export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_CUSTOMER_QUERY_PARAMS = 'SET_CUSTOMER_QUERY_PARAMS'
export const SET_CUSTOMER_REACHED_BOTTOM = 'SET_CUSTOMER_REACHED_BOTTOM'
export const SET_LOADING_MORE_CUSTOMER = 'SET_LOADING_MORE_CUSTOMER'
export const PUSH_CUSTOMER = 'PUSH_CUSTOMER'
export const UNSHIFT_CUSTOMER = 'UNSHIFT_CUSTOMER'
